import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {useEffect, useState} from "react";
import useAuthStore from '../mobile/store/authStore';

import AdminNotFoundPage from "./components/pages/AdminNotFoundPage";
import LoginPage from "./components/pages/LoginPage";
import DashboardPage from "./components/pages/DashboardPage";
import SystemPage from "./components/pages/SystemPage";
import MemberManagementPage from "./components/pages/MemberManagementPage";
import ReportManagementPage from "./components/pages/ReportManagementPage";
import NotificationManagementPage from "./components/pages/NotificationManagementPage";
import MeetingManagementPage from "./components/pages/MeetingManagementPage";
import PartnerPlaceApplicationManagementPage from "./components/pages/PartnerPlaceApplicationManagementPage";
import PartnerPlaceManagementPage from "./components/pages/PartnerPlaceManagementPage";
import EventManagementPage from "./components/pages/EventManagementPage";
import AnnouncementManagementPage from "./components/pages/AnnouncementManagementPage";
import PaymentManagementPage from "./components/pages/PaymentManagementPage";
import RiceTransactionManagementPage from "./components/pages/RiceTransactionManagementPage";
import RiceGrantAndRevokeManagementPage from "./components/pages/RiceGrantAndRevokeManagementPage";

const ProtectedAdminRoute = ({children, member, isLoading}) => {
    // 로딩 중이면 대기
    if (isLoading) {
        return <div>Loading...</div>; // 또는 로딩 스피너 컴포넌트
    }
    
    if (!member) {
        return <Navigate to="/admin" replace />;
    }

    if (member.role !== 'ROLE_ADMIN') {
        return <Navigate to="/admin" replace />;
    }

    return children;
};

const AdminRoutes = () => {
    const {checkAuth, member} = useAuthStore();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const initAuth = async () => {
            setIsLoading(true);
            await checkAuth();
            setIsLoading(false);
        };
        initAuth();
    }, [checkAuth]);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/admin" element={
                    isLoading ? <div>Loading...</div> : 
                    (member && member.role === 'ROLE_ADMIN') ? 
                    <Navigate to="/admin/dashboard" replace /> : 
                    <LoginPage />
                } />

                {/* 어드민 대시보드: 로그인한 어드민만 접근 가능 */}
                <Route path="/admin/dashboard" element={
                    <ProtectedAdminRoute member={member} isLoading={isLoading}>
                        <DashboardPage />
                    </ProtectedAdminRoute>
                } />
                <Route path="/admin/dashboard/system" element={
                    <ProtectedAdminRoute member={member} isLoading={isLoading}>
                        <SystemPage />
                    </ProtectedAdminRoute>
                } />
                <Route path="/admin/dashboard/members" element={
                    <ProtectedAdminRoute member={member} isLoading={isLoading}>
                        <MemberManagementPage />
                    </ProtectedAdminRoute>
                } />
                <Route path="/admin/dashboard/reports" element={
                    <ProtectedAdminRoute member={member} isLoading={isLoading}>
                        <ReportManagementPage />
                    </ProtectedAdminRoute>
                } />
                <Route path="/admin/dashboard/meetings" element={
                    <ProtectedAdminRoute member={member} isLoading={isLoading}>
                        <MeetingManagementPage />
                    </ProtectedAdminRoute>
                } />
                <Route path="/admin/dashboard/notifications" element={
                    <ProtectedAdminRoute member={member} isLoading={isLoading}>
                        <NotificationManagementPage />
                    </ProtectedAdminRoute>
                } />
                <Route path="/admin/dashboard/partner-places" element={
                    <ProtectedAdminRoute member={member} isLoading={isLoading}>
                        <PartnerPlaceManagementPage />
                    </ProtectedAdminRoute>
                } />
                <Route path="/admin/dashboard/partner-place-applications" element={
                    <ProtectedAdminRoute member={member} isLoading={isLoading}>
                        <PartnerPlaceApplicationManagementPage />
                    </ProtectedAdminRoute>
                } />
                <Route path="/admin/dashboard/events" element={
                    <ProtectedAdminRoute member={member} isLoading={isLoading}>
                        <EventManagementPage />
                    </ProtectedAdminRoute>
                } />
                <Route path="/admin/dashboard/announcements" element={  
                    <ProtectedAdminRoute member={member} isLoading={isLoading}>
                        <AnnouncementManagementPage />
                    </ProtectedAdminRoute>
                } />
                <Route path="/admin/dashboard/payments" element={
                    <ProtectedAdminRoute member={member} isLoading={isLoading}>
                        <PaymentManagementPage />
                    </ProtectedAdminRoute>
                } />
                <Route path="/admin/dashboard/rice-transactions" element={
                    <ProtectedAdminRoute member={member} isLoading={isLoading}>
                        <RiceTransactionManagementPage />
                    </ProtectedAdminRoute>
                } />
                <Route path="/admin/dashboard/rice-grant-and-revoke" element={
                    <ProtectedAdminRoute member={member} isLoading={isLoading}>
                        <RiceGrantAndRevokeManagementPage />
                    </ProtectedAdminRoute>
                } />
                {/* 그 외는 NotFound */}
                <Route path="*" element={<AdminNotFoundPage />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AdminRoutes;
